import React, {useState, useEffect} from "react";

export default function SoftshelljackePrimoFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M450.876,447.5c-0.21-3.209-3.389-51.2-6.28-62.75c-3.019-12.07-6.99-40.919-7.99-51.95
     c-1.02-11.149-14.01-85.059-17.029-92.099c-1.231-2.87-5.59-18.731-10.63-37.09c-7.061-25.7-15.841-57.681-19.37-65.91
     c-4.09-9.561-9.67-18.321-12.67-23.031c-1.21-1.9-2.25-3.54-2.301-3.839c0-1.361-11.89-11.22-23.379-16.97
     c-11.44-5.71-47.53-15.45-50.631-16.28c-0.08-1.661-0.55-11.92,0.01-17.77c0.15-1.61-1.4-4-2.35-5.291
     c-3.029-4.119-7.929-5.659-12.279-6.779c-5.73-1.471-11.471-2.571-17.061-3.29c-10.73-1.38-21.98-1.33-35.379,0.139
     c-7.491,0.821-13.59,1.91-19.21,3.43c-6.971,1.881-11.201,5.101-12.941,9.841c-0.229,0.639-0.409,1.29-0.55,1.829l-0.019,0.06
     l0.01,0.061c0.549,5.85,0.089,16.109,0.009,17.77c-3.109,0.83-39.2,10.57-50.63,16.28c-11.49,5.75-23.379,15.609-23.379,16.96
     c-0.051,0.309-1.1,1.949-2.311,3.849c-2.99,4.71-8.569,13.47-12.67,23.031c-3.519,8.229-12.309,40.21-19.369,65.91
     c-5.041,18.359-9.391,34.22-10.631,37.09c-3.01,7.04-16.01,80.95-17.019,92.099c-1.01,11.031-4.981,39.88-7.991,51.95
     c-2.889,11.55-6.07,59.541-6.279,62.75c-0.131,0.11-0.221,0.27-0.23,0.46c-0.02,0.31,0.15,0.581,0.42,0.67
     c18.65,6.441,31.37,8.17,39.66,8.17c4.24,0,7.309-0.46,9.42-0.96c0.599-0.139,1.019-0.67,1.109-1.34h0.03
     c0.031-0.169,0.87-4.66,2.13-11.359l0.051-0.08c-0.011,0-0.021-0.011-0.03-0.011c3.67-19.409,10.929-57.17,12.909-62.719
     c2.261-6.321,17.4-62.201,19.35-72.941c1.411-7.739,10.54-35.26,16.23-50.59c-0.1,13.311-1.01,73.95-1.02,74.601l-1.92,74.559
     c-0.009,0.13-1.65,13.491-1.49,20.491c0.1,4.409,6.17,8,11.25,10.229c3.5,1.54,7.25,2.54,11.141,2.971l66.729,7.34
     c0.13,0.939,0.56,2.019,1.771,2.559c1.269,0.571,8.349,0.97,15.709,0.97c6.091,0,12.36-0.27,15.68-0.939l0.121-0.031l0.07-0.099
     c0.809-1.091,1.01-2.29,1.029-3.231l32.25-3.47c2.891-0.31,5.85-0.58,8.71-0.83c7.54-0.67,15.341-1.359,22.851-3.009l0.82-0.191
     c6.56-1.42,18.77-4.079,18.949-12.269c0.111-5.031-0.689-13.22-1.17-17.651c-0.219-1.989-0.359-4.04-0.41-6.11l-1.83-71.289
     c-0.01-0.651-0.93-61.29-1.029-74.601c5.689,15.33,14.83,42.851,16.24,50.59c1.949,10.74,17.079,66.62,19.34,72.941
     c1.989,5.549,9.25,43.31,12.92,62.719c-0.01,0-0.021,0.011-0.03,0.011l0.04,0.08c1.269,6.699,2.099,11.19,2.139,11.359h0.021
     c0.099,0.67,0.519,1.201,1.119,1.34c2.1,0.5,5.181,0.96,9.42,0.96c8.281,0,21.011-1.729,39.66-8.17c0.27-0.089,0.44-0.36,0.42-0.67
     C451.096,447.769,451.006,447.609,450.876,447.5z"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          points="
     233.834,69.117 235.633,68.888 235.633,67.061 	"
        />
        <path
          fill={darkenColor}
          d="M299.957,59.72c-0.13,0.42-2.55,7.771-10.97,8.32c-8.47,0.56-20.28-0.28-21.36-0.36
     c-0.31-1.25-1.09-1.83-2.41-1.8c-0.989,0.03-1.95,0.01-2.96-0.01l-0.3-0.009c-1.729-0.031-3.46-0.091-5.19-0.151
     c-2.59-0.08-5.27-0.17-7.911-0.179h-1.378l-0.461,0.009c-3.84,0.04-6.78,0.191-9.52,0.47l-0.56,0.051
     c-1.081,0.109-2.2,0.209-3.27,0.55c-0.05,0.009-0.109,0.029-0.16,0.059c-0.57,0.27-0.64,0.7-0.59,0.941V67.7
     c-1.9,0.14-12.42,0.88-20.47,0.34c-8.18-0.54-10.71-7.5-10.96-8.27c0.13-0.52,0.3-1.11,0.51-1.69c1.66-4.519,5.75-7.61,12.5-9.429
     c5.59-1.511,11.66-2.601,19.109-3.42c13.351-1.461,24.551-1.511,35.231-0.141c5.56,0.721,11.269,1.82,16.971,3.28
     c4.25,1.09,9.029,2.58,11.929,6.54C298.287,55.66,300.077,58.231,299.957,59.72"
        />
        <path
          fill={darkenColor}
          d="M450.477,448v0.02c-28.041,9.68-42.561,8.66-48.721,7.19c-0.439-0.101-0.62-0.521-0.65-0.88
     c-0.02-0.37,0.1-0.86,0.551-1.05c12.91-5.26,24.88-6.639,33.91-6.639C442.697,446.641,447.997,447.5,450.477,448"
        />
        <path
          fill={darkenColor}
          d="M100.317,454.33c-0.03,0.359-0.211,0.779-0.641,0.88c-6.16,1.47-20.67,2.49-48.67-7.22
     c5.721-1.15,25.76-4.08,48.76,5.29C100.216,453.47,100.346,453.96,100.317,454.33"
        />
        <path
          fill={darkenColor}
          d="M229.897,217.94c-4.061-36.51-2.73-69.699-1.871-83.47L229.897,217.94z"
        />
        <path
          fill={darkenColor}
          d="M335.377,380.7c-4.05-36.511-2.729-69.7-1.86-83.47L335.377,380.7z"
        />
        <path
          fill={darkenColor}
          d="M163.907,380.7l1.859-83.47C166.636,311,167.957,344.189,163.907,380.7"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M235.751,436.722c-44.484-4.257-61.725-5.987-69.646-7.854c-3.108-0.734-6.062-1.972-8.764-3.674
     c-2.632-1.659-6.317-4.113-9.554-6.748"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M271.399,435.776c38.474-3.871,55.662-5.165,63.061-6.909c3.108-0.734,6.061-1.972,8.763-3.674
     c2.633-1.658,6.318-4.112,9.555-6.748"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M222.153,226.407c-5.649,0-6.735-0.576-7.425-1.219c-0.514-0.484-0.804-1.114-0.824-1.784c-0.249-4.773-1.21-68.727-1.525-89.78
     c-0.049-3.233-0.079-5.164-0.081-5.292v-1.939l1.856-0.354c2.122-0.465,4.485-0.707,6.977-0.707c3.71,0,6.663,0.538,7.424,0.711
     l1.767,0.35l0.068,1.812l2.181,97.783l-2.193,0.139C228.632,226.232,225.251,226.407,222.153,226.407z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M203.639,59.671
     c0.084-0.286,0.184-0.601,0.296-0.91c1.419-3.862,5.063-6.541,11.14-8.18c5.504-1.489,11.477-2.557,18.798-3.362
     c6.898-0.754,13.108-1.12,18.984-1.12c5.494,0,10.657,0.319,15.783,0.975c5.507,0.713,11.136,1.801,16.728,3.234
     c3.912,1.003,8.296,2.36,10.815,5.787c1.129,1.541,1.712,2.809,1.812,3.327"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M203.343,67.422
     c2.012,1.652,4.782,3.019,8.532,3.265c1.972,0.13,4.241,0.196,6.743,0.196c4.626,0,9.147-0.225,11.884-0.393"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M254.163,447.855c-7.854,0-14.044-0.437-15.025-0.75c-0.171-0.079-0.223-0.893-0.139-1.368l0.021-0.14
     c0.666-5.822,1.353-63.443,1.122-72.986c-0.098-4.291-0.414-43.432-0.748-84.87l-0.099-12.494
     c-0.35-43.933-0.711-89.362-0.932-105.504c-0.387-29.8-2.268-63.54-2.703-71.021l0.326-0.658l-0.38-0.572
     c-0.125-5.259-0.034-21.479,0.003-27.193h0.014l0.01,0.1v-1.511c0.537-0.085,1.097-0.138,1.618-0.187l0.587-0.064
     c2.731-0.271,5.595-0.41,9.265-0.447l0.487-0.012l1.323,0.001c2.389,0.01,4.844,0.087,7.219,0.161l0.608,0.019
     c1.735,0.059,3.487,0.119,5.228,0.15l0.263,0.01c0.664,0.013,1.31,0.025,1.956,0.025c0.324,0,0.648-0.002,0.97-0.01
     c0.12,0.67,0.103-0.656,0.068,0.268l-0.011,0.276c-0.069,2.31-0.008,4.616,0.051,6.846l0.009,0.377
     c0.044,1.414,0.099,3.16,0.099,4.828c0.041,1.944,0.091,3.843,0.141,5.744l0.07,2.707l0.3,10.396c0.091,2.988,0.18,5.983,0.28,8.97
     c0.097,3.308,0.204,6.616,0.312,9.931l0.348,10.298c0.089,2.819,0.186,5.64,0.283,8.468l0.987,27.758l-0.151,279.46l0.015,0.121
     l-0.001-0.04c0.009,0.147,0.031,0.257,0.044,0.315c0.043,0.203,0.197,1.07-0.063,1.901
     C264.97,447.604,260.047,447.855,254.163,447.855z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M52.772,437.317
     c2.189-0.411,8.363-1.476,13.604-1.476c0.792,0,1.534,0.025,2.218,0.074c-0.263,1.552-0.674,4.288-0.858,9.097
     c-0.697-0.015-1.38-0.023-2.046-0.023c-5.988,0-10.714,0.603-13.537,1.087"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M448.657,437.317c-2.189-0.411-8.363-1.476-13.604-1.476c-0.792,0-1.534,0.025-2.218,0.074c0.263,1.552,0.674,4.288,0.858,9.097
     c0.697-0.015,1.38-0.023,2.046-0.023c5.988,0,10.714,0.603,13.537,1.087"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M98.675,450.16
     c-8.827-3.4-18.062-5.41-27.505-5.987c0.164-3.441,0.443-5.626,0.661-7.004c5.128,0.359,17.871,1.778,27.923,7.236"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M132.814,122.959c2.567-3.647,20.278-26.34,68.026-34.137"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M297.992,67.422
     c-2.012,1.652-4.782,3.019-8.532,3.265c-1.972,0.13-4.241,0.196-6.743,0.196c-4.626,0-9.147-0.225-11.884-0.393"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M402.659,450.16
     c8.827-3.4,18.062-5.41,27.505-5.987c-0.164-3.441-0.443-5.626-0.661-7.004c-5.128,0.359-17.871,1.778-27.923,7.236"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M368.52,122.959
     c-2.567-3.647-20.278-26.34-68.026-34.137"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M327.639,389.167c-5.649,0-6.736-0.577-7.425-1.22c-0.515-0.484-0.804-1.113-0.824-1.783c-0.249-4.773-1.21-68.728-1.525-89.781
     c-0.049-3.232-0.079-5.163-0.081-5.291v-1.939l1.855-0.355c2.122-0.465,4.486-0.706,6.977-0.706c3.71,0,6.664,0.538,7.425,0.71
     l1.767,0.351l0.068,1.811l2.181,97.784l-2.193,0.139C334.118,388.991,330.736,389.167,327.639,389.167z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M171.643,389.167c5.649,0,6.736-0.577,7.425-1.22c0.514-0.484,0.804-1.113,0.824-1.783c0.249-4.773,1.21-68.728,1.525-89.781
     c0.049-3.232,0.079-5.163,0.081-5.291v-1.939l-1.855-0.355c-2.122-0.465-4.486-0.706-6.977-0.706c-3.711,0-6.664,0.538-7.425,0.71
     l-1.767,0.351l-0.068,1.811l-2.181,97.784l2.193,0.139C165.164,388.991,168.546,389.167,171.643,389.167z"
        />
        <path
          fill="#010101"
          d="M450.876,447.5c-0.21-3.209-3.389-51.2-6.28-62.75c-3.019-12.07-6.99-40.919-7.99-51.95
     c-1.02-11.149-14.01-85.059-17.029-92.099c-1.231-2.87-5.59-18.731-10.63-37.09c-7.061-25.7-15.841-57.681-19.37-65.91
     c-4.09-9.561-9.67-18.321-12.67-23.031c-1.21-1.9-2.25-3.54-2.301-3.839c0-1.361-11.89-11.22-23.379-16.97
     c-11.44-5.71-47.53-15.45-50.631-16.28c-0.08-1.661-0.55-11.92,0.01-17.77c0.15-1.61-1.4-4-2.35-5.291
     c-3.029-4.119-7.929-5.659-12.279-6.779c-5.73-1.471-11.471-2.571-17.061-3.29c-10.73-1.38-21.98-1.33-35.379,0.139
     c-7.491,0.821-13.59,1.91-19.21,3.43c-6.971,1.881-11.201,5.101-12.941,9.841c-0.229,0.639-0.409,1.29-0.55,1.829l-0.019,0.06
     l0.01,0.061c0.549,5.85,0.089,16.109,0.009,17.77c-3.109,0.83-39.2,10.57-50.63,16.28c-11.49,5.75-23.379,15.609-23.379,16.96
     c-0.051,0.309-1.1,1.949-2.311,3.849c-2.99,4.71-8.569,13.47-12.67,23.031c-3.519,8.229-12.309,40.21-19.369,65.91
     c-5.041,18.359-9.391,34.22-10.631,37.09c-3.01,7.04-16.01,80.95-17.019,92.099c-1.01,11.031-4.981,39.88-7.991,51.95
     c-2.889,11.55-6.07,59.541-6.279,62.75c-0.131,0.11-0.221,0.27-0.23,0.46c-0.02,0.31,0.15,0.581,0.42,0.67
     c18.65,6.441,31.37,8.17,39.66,8.17c4.24,0,7.309-0.46,9.42-0.96c0.599-0.139,1.019-0.67,1.109-1.34h0.03
     c0.031-0.169,0.87-4.66,2.13-11.359l0.051-0.08c-0.011,0-0.021-0.011-0.03-0.011c3.67-19.409,10.929-57.17,12.909-62.719
     c2.261-6.321,17.4-62.201,19.35-72.941c1.411-7.739,10.54-35.26,16.23-50.59c-0.1,13.311-1.01,73.95-1.02,74.601l-1.92,74.559
     c-0.009,0.13-1.65,13.491-1.49,20.491c0.1,4.409,6.17,8,11.25,10.229c3.5,1.54,7.25,2.54,11.141,2.971l66.729,7.34
     c0.13,0.939,0.56,2.019,1.771,2.559c1.269,0.571,8.349,0.97,15.709,0.97c6.091,0,12.36-0.27,15.68-0.939l0.121-0.031l0.07-0.099
     c0.809-1.091,1.01-2.29,1.029-3.231l32.25-3.47c2.891-0.31,5.85-0.58,8.71-0.83c7.54-0.67,15.341-1.359,22.851-3.009l0.82-0.191
     c6.56-1.42,18.77-4.079,18.949-12.269c0.111-5.031-0.689-13.22-1.17-17.651c-0.219-1.989-0.359-4.04-0.41-6.11l-1.83-71.289
     c-0.01-0.651-0.93-61.29-1.029-74.601c5.689,15.33,14.83,42.851,16.24,50.59c1.949,10.74,17.079,66.62,19.34,72.941
     c1.989,5.549,9.25,43.31,12.92,62.719c-0.01,0-0.021,0.011-0.03,0.011l0.04,0.08c1.269,6.699,2.099,11.19,2.139,11.359h0.021
     c0.099,0.67,0.519,1.201,1.119,1.34c2.1,0.5,5.181,0.96,9.42,0.96c8.281,0,21.011-1.729,39.66-8.17c0.27-0.089,0.44-0.36,0.42-0.67
     C451.096,447.77,451.006,447.609,450.876,447.5 M450.206,447.29c-3.02-0.59-9.309-1.531-17.629-1.25
     c-0.18-6.021-0.71-8.991-0.96-10.42c-0.04-0.241-0.08-0.441-0.101-0.601c6.37-0.76,16.291,1.131,17.931,1.461
     C449.856,441.98,450.126,446.02,450.206,447.29 M350.936,94.451c11.721,5.86,22.61,15.219,23.011,16.37
     c-1.031,3.66-2.031,7.309-3.011,10.939c-2.209-3.26-20.279-27.639-70.73-35.67c0.951-1.25,1.351-2.08,1.371-2.109
     c0.82-1.641-0.18-4.41-0.71-5.65C306.046,79.72,339.956,88.96,350.936,94.451 M300.987,83.701c-0.051,0.11-5.66,11.729-26.75,14.2
     c-4.631,0.319-5.62,0.17-5.821,0.099c-0.08-2.82-0.16-5.65-0.24-8.48c-0.08-2.81-0.15-5.609-0.22-8.399
     c0-1.63-0.049-3.29-0.089-4.89c-0.071-2.311-0.14-4.711-0.06-7.061c0.01-0.309,0.02-0.469,0.029-0.559c0-0.111,0-0.171-0.029-0.261
     c1.48,0.101,7.959,0.54,14.52,0.54c2.299,0,4.599-0.059,6.699-0.2c6.4-0.42,9.5-4.579,10.791-7.029
     c-0.311,5.74,0.029,13.79,0.119,15.74l-0.27-0.07l0.321,0.65C300.006,78.02,301.907,81.861,300.987,83.701 M201.997,58.081
     c1.66-4.52,5.75-7.611,12.5-9.43c5.589-1.511,11.66-2.601,19.109-3.42c13.351-1.461,24.551-1.511,35.23-0.141
     c5.561,0.721,11.27,1.821,16.971,3.281c4.25,1.089,9.029,2.58,11.93,6.54c0.55,0.75,2.34,3.32,2.219,4.809
     c-0.129,0.42-2.549,7.771-10.969,8.321c-8.471,0.559-20.281-0.281-21.361-0.361c-0.309-1.25-1.089-1.83-2.41-1.8
     c-0.989,0.031-1.95,0.01-2.96-0.009l-0.299-0.01c-1.73-0.03-3.46-0.091-5.191-0.151c-2.59-0.08-5.269-0.169-7.91-0.179h-1.379
     l-0.461,0.01c-3.84,0.04-6.779,0.19-9.519,0.469l-0.561,0.051c-1.08,0.109-2.199,0.209-3.27,0.55
     c-0.049,0.01-0.109,0.029-0.16,0.059c-0.57,0.27-0.639,0.701-0.59,0.941v0.09c-1.9,0.139-12.419,0.88-20.469,0.34
     c-8.181-0.541-10.71-7.5-10.96-8.271C201.617,59.25,201.787,58.66,201.997,58.081 M201.436,77.98l0.32-0.65l-0.259,0.07
     c0.089-1.95,0.429-10,0.109-15.74c1.291,2.45,4.4,6.609,10.801,7.029c8.019,0.53,18.469-0.19,20.509-0.34
     c-0.019,2.99-0.169,24.28-0.009,29.681c-0.37,0.059-1.611,0.149-5.7-0.13c-21.101-2.471-26.71-14.09-26.771-14.211
     C199.526,81.861,201.416,78.02,201.436,77.98 M150.497,94.451c10.969-5.491,44.879-14.731,50.07-16.12
     c-0.53,1.24-1.53,4-0.711,5.639c0.011,0.03,0.41,0.861,1.371,2.12c-50.461,8.031-68.53,32.41-70.74,35.67
     c-0.971-3.63-1.971-7.269-3-10.929C127.977,109.59,138.817,100.29,150.497,94.451 M51.977,436.48
     c1.649-0.33,11.569-2.221,17.939-1.461c-0.03,0.16-0.06,0.36-0.099,0.601c-0.26,1.429-0.78,4.389-0.971,10.42
     c-8.309-0.281-14.609,0.66-17.63,1.25C51.307,446.02,51.577,441.98,51.977,436.48 M99.676,455.21
     c-6.16,1.47-20.67,2.491-48.67-7.219c5.721-1.151,25.76-4.08,48.76,5.29c0.45,0.189,0.58,0.679,0.551,1.05
     C100.287,454.69,100.106,455.109,99.676,455.21 M100.567,453.109c-0.151-0.18-0.33-0.34-0.551-0.43
     c-11.34-4.619-21.949-6.269-30.519-6.619c0.179-5.98,0.7-8.91,0.959-10.33c0.041-0.271,0.081-0.481,0.101-0.66
     c2.409,0.099,19.459,1,31.829,8.3C101.546,447.859,100.897,451.32,100.567,453.109 M134.737,307.27
     c-1.95,10.73-17.061,66.53-19.321,72.84c-2.019,5.65-9.219,43.08-12.9,62.591c-13.31-7.761-31.769-8.271-32.22-8.29
     c-6.25-0.84-16.12,0.98-18.27,1.4c1.171-15.801,3.381-42.67,5.44-50.9c3.021-12.1,7-41,8-52.05
     c1.021-11.141,13.981-84.891,16.981-91.901c1.25-2.919,5.61-18.799,10.659-37.179c7.06-25.681,15.83-57.641,19.341-65.821
     c4.079-9.52,9.639-18.25,12.62-22.94c1.029-1.619,1.649-2.6,2.01-3.229c9.75,34.629,16.82,67.919,21.589,101.74
     c1.901,13.45,2.951,28.149,2.951,41.399C145.987,269.87,136.197,299.219,134.737,307.27 M236.247,446.331L169.636,439
     c-3.819-0.419-7.5-1.4-10.95-2.919c-4.91-2.151-10.77-5.581-10.859-9.641c-0.161-6.949,1.469-20.27,1.49-20.43l1.92-74.599
     c0.01-0.68,1.029-68.521,1.029-76.43c0-13.291-1.05-28.041-2.949-41.551c-4.28-30.319-10.41-60.229-18.66-91.069l0.16,0.099
     c0.16-0.28,17.039-27.339,70.869-35.79c3.051,3.71,10.371,10.111,25.461,11.88c3.6,0.25,5.119,0.22,5.789,0.12
     c0.25,4.22,2.311,39.811,2.721,71.111c0.229,17.51,0.65,70.099,1.019,116.489c0.35,44.021,0.651,82.041,0.76,86.4
     c0.23,9.52-0.449,66.861-1.109,72.6C236.317,445.32,236.237,445.75,236.247,446.331 M269.886,444.82
     c0.011,0.029,0.591,2.309-0.689,4.139c-7.58,1.48-28.931,0.871-30.861,0c-1.879-0.839-1.379-3.54-1.37-3.589
     c0.67-5.771,1.351-63.191,1.12-72.71c-0.109-4.361-0.429-44.201-0.759-86.391c-0.37-46.399-0.79-98.989-1.02-116.5
     c-0.431-32.399-2.61-69.399-2.74-71.459l0.059-0.101l-0.069-0.089c-0.16-5.231-0.011-27.031,0.01-29.821V67.57l0.01-0.03
     l-0.02-0.05c-0.011-0.051,0.029-0.141,0.23-0.241l-0.14-0.29l0.25,0.26c0.97-0.3,2.06-0.409,3.1-0.51l0.57-0.059
     c2.72-0.271,5.63-0.42,9.459-0.461l0.451-0.01h1.379c2.631,0.01,5.301,0.101,7.891,0.181c1.73,0.059,3.46,0.12,5.189,0.149
     l0.311,0.01c0.969,0.021,1.98,0.041,2.99,0.011c1.019-0.05,1.539,0.359,1.76,1.34c0.109,0.45,0.169,0.599,0.189,0.7
     c-0.01,0.09-0.02,0.25-0.029,0.58c-0.08,2.369-0.01,4.769,0.059,7.099c0.04,1.59,0.091,3.25,0.091,4.88
     c0.069,2.8,0.14,5.601,0.219,8.401c0.08,3.13,0.18,6.26,0.27,9.38c0.101,3.32,0.201,6.639,0.3,9.969
     c0.11,3.401,0.221,6.79,0.33,10.191c0.111,3.349,0.221,6.689,0.33,10.04l1.27,36.22l-0.15,279.41L269.886,444.82z M350.197,331.419
     l1.829,71.29c0.051,2.081,0.19,4.15,0.41,6.161c0.48,4.42,1.28,12.58,1.17,17.569c-0.17,7.67-12.049,10.261-18.43,11.65l-0.83,0.18
     c-7.47,1.65-15.25,2.34-22.769,3c-2.861,0.261-5.821,0.521-8.721,0.83l-32.199,3.471c-0.04-0.43-0.1-0.76-0.131-0.87l0.15-279.38
     l-1.269-36.231c-0.111-3.349-0.221-6.7-0.33-10.04c-0.111-3.399-0.221-6.8-0.33-10.189c-0.1-3.32-0.201-6.651-0.3-9.971
     c0-0.079-0.011-0.149-0.011-0.229c0.65,0.109,2.17,0.139,5.86-0.12c15.09-1.76,22.401-8.17,25.441-11.871
     c53.809,8.451,70.719,35.51,70.88,35.79l0.159-0.099c-8.25,30.84-14.379,60.75-18.659,91.079c-1.911,13.5-2.96,28.25-2.96,41.541
     C349.157,262.889,350.186,330.73,350.197,331.419 M386.016,380.109c-2.26-6.31-17.369-62.11-19.319-72.84
     c-1.47-8.05-11.261-37.399-16.89-52.34c0.01-13.25,1.049-27.949,2.949-41.399c4.77-33.821,11.84-67.111,21.6-101.75
     c0.35,0.639,0.98,1.63,2,3.239c2.99,4.69,8.551,13.42,12.631,22.94c3.5,8.18,12.279,40.14,19.33,65.821
     c5.05,18.38,9.42,34.26,10.67,37.179c3,7.01,15.96,80.76,16.969,91.901c1.01,11.05,4.98,39.95,8.01,52.05
     c2.06,8.23,4.271,35.099,5.431,50.9c-2.141-0.42-12.011-2.24-18.271-1.4c-0.44,0.019-18.899,0.529-32.219,8.29
     C395.227,423.19,388.037,385.76,386.016,380.109 M399.037,443.371c12.37-7.3,29.419-8.201,31.83-8.3
     c0.03,0.179,0.059,0.389,0.11,0.66c0.25,1.42,0.77,4.35,0.949,10.34c-8.57,0.34-19.179,1.99-30.51,6.609
     c-0.219,0.09-0.4,0.25-0.549,0.43C400.526,451.32,399.886,447.859,399.037,443.371 M450.477,448.02
     c-28.041,9.681-42.561,8.66-48.721,7.19c-0.439-0.1-0.62-0.52-0.65-0.879c-0.02-0.371,0.1-0.861,0.551-1.05
     c12.91-5.261,24.88-6.64,33.91-6.64c7.13,0,12.43,0.859,14.91,1.359V448.02z"
        />
        <path
          fill="#010101"
          d="M179.367,290.14c-6.95-1.51-13.781-0.01-13.841,0l-0.25,0.061l-2.18,97.53l0.311,0.019
     c1.17,0.071,4.849,0.281,8.21,0.281c2.92,0,5.599-0.16,6.179-0.701c0.161-0.15,0.201-0.32,0.201-0.41
     c0.29-5.269,1.609-95.54,1.63-96.45v-0.269L179.367,290.14z M165.766,297.231c0.87,13.769,2.191,46.959-1.859,83.47
     L165.766,297.231z M177.356,386.85c-0.52,0.65-7.239,0.65-13.56,0.271c6.14-48.281,2.5-92.441,2.151-96.401
     c1.3-0.25,7.079-1.229,13.019,0C178.886,296.201,177.627,381.76,177.356,386.85"
        />
        <path
          fill="#010101"
          d="M334.016,290.46l-0.01-0.259l-0.25-0.061c-0.059-0.01-6.889-1.51-13.84,0l-0.259,0.061v0.269
     c0.019,0.91,1.34,91.181,1.63,96.441c0,0.099,0.04,0.269,0.2,0.419c0.58,0.54,3.26,0.701,6.179,0.701c3.36,0,7.041-0.21,8.21-0.281
     l0.31-0.019L334.016,290.46z M335.376,380.701c-4.049-36.511-2.729-69.701-1.86-83.47L335.376,380.701z M321.936,386.891
     c-0.279-5.121-1.539-90.69-1.619-96.171c5.939-1.229,11.72-0.25,13.019,0c-0.349,3.96-3.99,48.12,2.151,96.4
     C329.166,387.5,322.447,387.5,321.936,386.891"
        />
        <path
          fill="#010101"
          d="M228.526,127.7v-0.26l-0.25-0.05c-0.069-0.02-6.899-1.52-13.849,0l-0.26,0.05l0.01,0.27
     c0.009,0.91,1.33,91.18,1.631,96.441c0,0.109,0.029,0.269,0.189,0.419c0.59,0.55,3.26,0.7,6.18,0.7c3.36,0,7.04-0.209,8.21-0.28
     l0.32-0.02L228.526,127.7z M229.897,217.94c-4.06-36.51-2.73-69.7-1.871-83.47L229.897,217.94z M216.457,224.13
     c-0.29-5.12-1.55-90.69-1.63-96.16c5.94-1.239,11.72-0.26,13.029-0.01c-0.349,3.96-4,48.12,2.151,96.4
     C223.677,224.74,216.957,224.75,216.457,224.13"
        />
      </g>
    </svg>
  );
}
